module.exports = __webpack_public_path__ + "img/blog-img-3.7556a268.jpg";